import i18nInstance from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnEn from './translation.en-en.json';

// the translations
const resources = {
    en: {
        translation: translationEnEn
    }
};

i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export { default } from "i18next";